// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".financial-highlights-home {\n  background-color: white;\n}\n.financial-highlights-home__content {\n  margin-top: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
